import React from 'react'
import { Link as RouterLink, useLocation } from 'react-router-dom'
import {
  Typography,
  Link
} from '@mui/material'


const Navigation = () => {
  const location = useLocation();
  const isActive = (path) => location.pathname === path;

  const linkStyle = {
    backgroundColor: 'rgba(0, 0, 0, 0.85)',
    padding: '4px 8px',
    borderRadius: '4px',
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 1rem',
        height: '54px',
        position: 'sticky',
        top: 0,
        zIndex: 1002,
      }}
    >
        <Link
          component={RouterLink}
          to="/"
          sx={{
            ...linkStyle,
            color: isActive('/') ? 'white' : '#ECEDFEFF',
            fontWeight: isActive('/') ? 'bold' : 'normal',
          }}
          underline="hover"
        >
          <Typography sx={{ textAlign: 'left', fontFamily: "'Radar'", fontSize: '14px'}}>NORMAN PONTE</Typography>
        </Link>
        <div>
        <Link
          component={RouterLink}
          to="/about"
          sx={{
            ...linkStyle,
            color: isActive('/about') ? 'white' : '#ECEDFEFF',
            fontWeight: isActive('/about') ? 'bold' : 'normal',
          }}
          underline="hover"
        >
          About
        </Link>
        <Link
          component={RouterLink}
          to="/notes"
          sx={{
            ...linkStyle,
            color: isActive('/notes') ? 'white' : '#ECEDFEFF',
            fontWeight: isActive('/notes') ? 'bold' : 'normal',
          }}
          underline="hover"
        >
          Notes
        </Link>
        <Link
          component={RouterLink}
          to="/reviews"
          sx={{
            ...linkStyle,
            color: isActive('/reviews') ? 'white' : '#ECEDFEFF',
            fontWeight: isActive('/reviews') ? 'bold' : 'normal',
          }}
          underline="hover"
        >
          Reviews
        </Link>
        </div>
    </div>
  )
}

export default Navigation
